module.exports = __webpack_public_path__ + "static/img/ba19cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/swipe_02.png
// module id = 701
// module chunks = 2